import {IObjectData, ISyncField} from "../../../index";
import {nsSyncFields} from "../../../req/nsSyncFields";
import TObjectData_basic = nsSyncFields.TObjectData_basic;

export interface IDataset {
    departments: TObjectData_basic[] | null
    original: IObjectData | null
    syncfields: KnockoutObservable<ISyncField[] | null>
    usedValues: { SourceId: string[]; EmployeeNumber: string[]; Socialsecuritynumber: string[] } | null
}

interface IModelParams {
    dataset: IDataset
}

type TOperationType = 'create' | 'edit'